import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundHandleKey = this.handleKey.bind(this)
    this.boundHandleContextMenu = this.handleContextMenu.bind(this)

    document.addEventListener("keydown", this.boundHandleKey)
    document.addEventListener("contextmenu", this.boundHandleContextMenu)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKey)
    document.removeEventListener("contextmenu", this.boundHandleContextMenu)
  }

  handleKey(event) {
    if (
      (event.ctrlKey || event.metaKey) &&
      ["s", "p", "c", "x"].includes(event.key.toLowerCase())
    ) {
      event.preventDefault()
      alert("This action is disabled!")
    }
  }

  handleContextMenu(event) {
    event.preventDefault()
    alert("Right click is disabled!")
  }
}
